'use client';
import e__default, { createContext, useContext, useMemo } from 'react';

function _define_property(e, n, t) {
    return n in e ? Object.defineProperty(e, n, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[n] = t, e;
}
function _object_spread(e) {
    for(var n = 1; n < arguments.length; n++){
        var t = null != arguments[n] ? arguments[n] : {}, r = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), r.forEach(function(n) {
            _define_property(e, n, t[n]);
        });
    }
    return e;
}
const getComponentConfigProvider = (o)=>{
    let i = createContext({});
    function useInterComponentConfigCtx() {
        return useContext(i);
    }
    i.displayName = `${o}InternalComponentConfig`;
    let InternalComponentConfigProvider = ({ config: n, children: t })=>{
        let o = useInterComponentConfigCtx(), p = useMemo(()=>_object_spread({}, o, n), [
            n,
            o
        ]);
        return e__default.createElement(i.Provider, {
            value: p
        }, t);
    };
    return InternalComponentConfigProvider.displayName = 'InternalComponentConfigProvider', [
        InternalComponentConfigProvider,
        useInterComponentConfigCtx,
        i
    ];
};

export { getComponentConfigProvider };
